import { graphql } from "babel-plugin-relay/macro";

export const SHOW_ANSWER_BUTTON_FRAGMENT = graphql`
	fragment showAnswersButton_LearnOpportunityFragment on LearnOpportunityV2 {
		id
		typeDefinition {
			definitionType
			... on LearnOpportunityELearningContentTypeDefinition {
				showAnswerElements {
					id
					elementType
					... on MultipleChoiceElementV2 {
						question
						answerOptions {
							answer
							isCorrect
						}
					}
				}
			}
		}
		root {
			structureDefinition {
				... on LearnOpportunityRootStructureDefinition {
					extension {
						... on LearnOpportunityRootExtensionImpl {
							configConsequences {
								showAnswerExpired
								showAnswerFrom
							}
						}
					}
				}
			}
		}
	}
`;
